/*
 * @Author: JamesWong
 * @Description: 英文主入口
 * @Date: 2018-11-29 13:48:16
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-07 01:40:48
 */
import main from './main'
import appversion from './appversion'
import channel from './channel'
import warehouse from './warehouse'
import activeCode from './activeCode'
import account from './account'
import payment from './payment'
import screen from './screen'
import slip from './slip'
import self from './self'
import inout from './inout'
import note from './note'
import newSlip from './newSlip'
import contract from './contract'
import collaboraivePlatform from './collaboraivePlatform'
import report from './report'
import receipt from './receipt'
import home from './home'

export default {
  main,
  home,
  appversion,
  receipt,
  channel,
  warehouse,
  activeCode,
  account,
  payment,
  screen,
  slip,
  self,
  inout,
  newSlip,
  note,
  contract,
  collaboraivePlatform,
  report
}



// WEBPACK FOOTER //
// ./src/i18n/en/index.js